import { render, staticRenderFns } from "./YvTable.vue?vue&type=template&id=30a66283&scoped=true&"
import script from "./YvTable.vue?vue&type=script&lang=js&"
export * from "./YvTable.vue?vue&type=script&lang=js&"
import style0 from "./YvTable.vue?vue&type=style&index=0&id=30a66283&scoped=true&lang=scss&"
import style1 from "./YvTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a66283",
  null
  
)

export default component.exports